module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break--Body-",
    attrs: {
      "id": "_idParaDest-2",
      "lang": "en-US"
    }
  }, [_vm._v("The Dingus")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Gregory Frost")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("All Meyers wanted to know was how Kid Willette, that he’d personally educated in the ring his last two years as a trainer, had ended up dead—and not just dead, but beaten, mangled, and dismembered dead. It didn’t make sense. It shouldn’t have been. Nobody could put a glove on Willette unless he wanted them to. Unless he’d been bought. That was the only time he’d ever gone down. Meyers knew that better than anybody.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("So when he walked into the Sixth District station to find Detective Bulbitch, he just wanted a simple explanation: Kid had been doped; Kid had been drunk; Kid had been wounded. He thought he would hear an answer that would let him go home from his night shift in the taxi, hoist a farewell shot of bourbon in commemoration, and then go to sleep untroubled by impossibilities.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He found Bulbitch at his desk, sharpening a pencil with a pocketknife. The shavings were sprinkling down onto his belly. His pink skull, graced with all of seven remaining hairs, glistened as if the pencil was giving him a very hard time.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Meyers drew the folded "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Inquirer ")]), _vm._v("from his armpit, opened and tossed it in front of the detective. Bulbitch looked up. For an instant Meyers saw fear—the same fear he glimpsed in people all the time when they first got a look at him. Then Bulbitch’s face widened into amusement. “Well, if it ain’t my most pugilist. How you been keepin’?” Meyers made a nod at the paper, where the front-page headline proclaimed, “Roadhouse Horror.” It was so big that even the national story following up on Truman’s kicking MacArthur out of command had been squeezed into a sidebar.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Bulbitch didn’t bother to look. “You still driving the cab?” he asked, and when Meyers persisted in saying nothing, he folded the knife and sat upright. He brushed the shavings like crumbs off his shirt and tie. “Yeah, all right,” he said. “Okay. I figured you’d hear about it. Expect the word’s out everywhere from Jack O’Brien’s to the Christian Street Y by now.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("And so the story unfolded.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Red’s Roadhouse out in Paoli was one of those two-story places slapped together with boards that had probably started life as a barn. The main hall had sawdust on the floor and a bar that was big enough for a catered wedding party to circle. On the second floor and in the back were the rented rooms, one of which they even had the chutzpah to call a “suite.” It was to this suite that Cody Aldred and his three enforcers had retreated for some R&R after a few weeks of breaking legs. The owner of the place, amaz"), _c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("ingly enough named Red, swore up and down that he didn’t know that Cody had brought in any working girls. How was he to know the women weren’t the men’s wives? It was a question that nobody answered as they were too busy laughing, seeing as how Red employed a half-dozen chippies of his own in the second-floor rooms. So, a little past midnight the night before, in the main room, at least two dozen people had been lounging in various states of blur. Those who still remained in the aftermath—including ever-reliable Red—agreed that no one else had come in. Nobody at all had entered Cody’s suite.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("And yet, in something like five minutes, according to everyone in the place, Cody and all three of his boys had been butchered. Torn to pieces. The three chippies were unharmed, and not one of them could explain what had happened.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("There’d been noise, something that howled like a gale and rattled the brass knob and shook the door on its hinges. The screams, someone said, were the screams of men being slid quick into hell. Only when it was over—and silent—did Red work up the gumption to go look. He didn’t even reach the door before the three chippies in there started their own caterwauling. Red paused with his hand on the knob, and that was when he noticed that the sawdust under his feet was turning wine dark, the stain spreading outward. The shrieking went on and on, but Red backed all the way to the bar, where he grabbed some change and hurried to the pay phone on the outside wall. Nobody else went for the door in his absence, although maybe one or two sidled on out of the roadhouse.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Tough guy, old Red,” said Bulbitch. “Uses himself a little baseball bat with a rebar center when somebody acts up in his establishment. But even he wasn’t gonna open that door. And, Meyers, you ought to leave it closed, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Meyers kept his hands shoved deep in his pockets. He rocked like a punching bag, his mind sifting the details. Bulbitch grabbed a pack of Camels off his desk, jerked one cigarette out, and put his lips around it to draw it from the pack.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“So,” Meyers finally, casually said, “Kid was with Cynthia, huh.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yeah.” Bulbitch’s fingers had just scissored on the cigarette, but stopped. He scowled with the realization that he’d been played, and he stared up at Meyers without lifting his head. “And you have now got all the information you’re getting, Mr. Meyers.” He rose up, his head even with Meyers’s neck. “You listen to me now. Leave it. This isn’t Montgomery versus Mouzon at Shibe Park. Ain’t any rules here. This is somebody did something so awful we’re gonna have to invent a new word to call it. And anyway, Kid Willette "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("ruined ")]), _vm._v("you in the fight biz, so what in hell is it you think you owe his ghost?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Meyers pulled the newspaper to himself. The picture on the front page was of a pile of trash beside what might have been a body under a sheet. “Nothing,” he said. “Not a goddamned thing. I was just curious, was all.” He took the paper and left.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The following night, whenever he had a fare that dropped anywhere close to Third and Race Streets, Meyers trolled over to the DR Bridge and drove the Crawl. He had no idea where Cynthia lived, but he knew where she worked when she hadn’t been hired for a night and hauled out to Paoli.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The third time through the Crawl that night, one of the working girls hailed him and told him to take her to Spruce and Twenty-Second. On the way he asked if she’d happened to see Cynthia.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She told him, “Not tonight, I ain’t, on account of her pimp dragged her over to South and Second till things settle down. And you didn’t hear that from me.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("After dropping her off, Meyers cut over to South and then drove straight down toward the Delaware; about the time he crossed Broad he remembered to turn off his light.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He parked the cab and got out, then strolled north along Second. This was the turf of old money, and a hooker had to blend a bit. He knew he might not find her—she might have scored a john already. But he got lucky.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Cynthia had a little dog on a string, a Pekinese, and she was walking it up and down the sidewalk between South and Lombard. Her platinum hair all but glowed under the streetlights. Meyers wondered what she did with the dog.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("As he came nearer, she paused and made a show of taking out a cigarette. He shook his head in the darkness as he drew up. “You know, I still don’t smoke,” he told her.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Her pose relaxed, and she stared hard at him. “Oh, "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("you")]), _vm._v(". I mighta known.” She pulled out a lighter and torched her own smoke. Her hand might have been shaking. “You looking for a tumble tonight, Pants-on-Fire?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Not really.” He held out his hand as if inviting her to dance. Between two fingers was a folded ten-dollar bill. “I need to talk to you, Cyn.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You think so?” Her jaw clicked, and she shifted it from side to side. Cynthia had suffered at the hands of a boyfriend, a psychopathic fighter, back in the days Meyers had been training Willette. The boyfriend had dislocated her jaw, and whoever had fixed it hadn’t set it right, with the result that it clicked sometimes when she spoke. If it hurt, she never said. Meyers had been on hand the night the boyfriend had tried to murder his opponent in the ring, and the opponent’s trainer had taken a three-legged stool to him. One leg had driven right into his brain, almost immediately making the world a significantly better place. Somehow, Cynthia had ended up going home with Meyers that night. She’d stayed till morning. Mostly, they’d gotten drunk while she tried to figure out why she was crying her eyes out over “a rotten dead bastard,” and Meyers had insisted on paying her like any john. It was some strange matter of protocol and respect that made sense only to him. In the end, as a compromise, she’d charged him for an hour of her time. He still didn’t know what to call what had happened between them.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He said, “You gotta talk to me a little bit. You were with Kid.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She flicked the cigarette away and lit another. “I didn’t think this was no social call.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Who did it, Cyn?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Jesus, Meyers.” She drew herself up, and for a moment he felt like she was bigger than he was. “Do you know, I got bounced to three different cells in three different station houses last night? Wasn’t allowed to sleep and damn near not to take a piss, and they just asked and asked and asked, but they got nothing for their trouble. Ten-dollar bill buys you the same as they got, but it’s your money, honey.” She snatched it from between his fingers.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Well, at least tell me the way it happened. I know you liked Willette.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She took a deep drag. The dog pulled her a couple of feet along the sidewalk so that he could sniff around a skinny tree. “Yeah, he was nice, for a handsome boy with a wad of bills and no sense.” The dog whimpered then, and she said, “Come on, Johnny, I gotta walk.” ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("They strolled side by side, like two old friends in no hurry to get anywhere. “What happened is, I don’t know what happened. They was three back rooms made up that suite—suite, like they’s a big luxury hotel and not a hole you could raise pigs in. I was, you know, doing Kid. And then all of a sudden, somebody’s screaming, and I mean screaming like their legs was being sawed off. It was Cody. Kid pushed me off him, snapped up his braces and charged right outten that room. No shirt, and he was stuffin’ himself back in his trousers with one hand and picking up his gun with the other.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“He had a gun?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“They all had guns, honey. Anyway, he charged out of that room like a bull, and the screaming, it stopped just for a second. Couple of doors slammed. And then it was back, but it was some other voice, and some shots, and then even more screaming. Kid that time. You got no idea how awful it was. I crawled under the bed with the cockroaches and the condoms and the mouse shit, and I stayed there. “And then it just stopped, ya know? Everything went quiet.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Some time passed. I got up and put on Kid’s jacket and snuck out to see. I woulda bolted, but Dottie come out of the next room. She’d been with both of Cody’s other guys, and I don’t know whose turn it was, so don’t ask. You probably know Dottie. She stayed home tonight like I shoulda.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What about the third girl?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Her.” She shook her head at some memory. “Cody had her with him already. She just got off the boat. Acted like she only spoke enough English to order a sandwich maybe.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Off the boat from where?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Estonia—is that a place?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yeah.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Okay, then.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The dog wrapped himself around a light pole. Meyers asked, “What are you not saying here, Cyn?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She pulled the dog backwards to untangle him. “Dunno what. You’d seen her, you’d understand. Big, shiny eyes. Crazy eyes."), _c('span', {
    staticClass: "Bold-Style",
    attrs: {
      "lang": "en-US"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Course, we all had ’em right about then, didn’t we?” She met his gaze as if his calm perplexity could answer for everything. “Cody said her name was Yuliya, like Julia but with a "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Y")]), _vm._v(". He was gonna hand her over to Mr. Drozdov later.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Cody pimping for the boss?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She shrugged. “Hey, it’s a business, isn’t it? You get paid and go where you go, same as a cabbie.” He ignored that. “And maybe with Drozdov’s reputation, ya gotta go all the way to Estonia to find somebody who don’t know any better.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He chewed on that. “So she was with Cody the whole time?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Me and Dottie found her sprawled in a chair, covered in blood.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Didn’t have a stitch on.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Then "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("she ")]), _vm._v("saw what happened.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Cynthia waved one hand around in a little circle. “What she told the cops was, the two of them was playing, you know, the way Cody liked it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What’s that supposed to mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“He’d tied her to the chair. I been with him once or twice. It’s like he’s tryin’ it out ’cause the boss does it. Only nobody’s afraid of being tied up by "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Cody")]), _vm._v(", ya know?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Meyers knew. Drozdov had dipped into the fight game awhile, hadn’t he, and more people seemed to get hurt on those occasions. Somehow Drozdov and the mob accommodated each other, kept to their respective territories. He must have had connections they appreciated. There were stories about how Drozdov liked to inflict pain, in particular how he liked to play with a boys’ wood-burning set. He’d been arrested two years back after a couple of mutilated hookers had been fished out of the Delaware. They’d been tortured, burned and scarred with an iron of some kind, and somebody had fingered Drozdov, or maybe the cops had just heard the same stories as everybody else. Either nothing could be proven or he’d bought the right people to make the charges go away. Hookers and hired muscle—nobody cared about either one Meyers shook himself back to the present. “Okay, so Cody tied up this dame.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Said he blindfolded her and the second she tugged it off, she was hit in the face with blood like out of a fire hose—and that’s how it looked, all right. Feet was still tied to the chair. We seen her and we ran into the room before we knew what was … what all the lumps on the floor was.” Her chin trembled and she clamped her lips together and shot him an accusatory glance. After a minute she went on. “Dottie started screaming, and then this doll comes around, and she starts screaming, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You were in shock, all three of you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Sure.” In the streetlight glow he watched her revisit the moment, watched her face pulled by awful currents of memory. “There was four bodies in there, John. The stink. And you couldn’t look anywhere at all. You just …”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He tried but could not fathom how it had happened. How could nobody have witnessed Kid Willette’s demise?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I’m cold,” Cynthia said abruptly. “I think I’m sick, you know?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Probably oughta go home, like Dottie. Stay in bed.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I’ll give you a lift,” he said. “On the house.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You let Snuffles in there, too?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Meyers and the weepy-eyed dog considered each other. “So long as he’s done his business,” he said. They walked over to his cab.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Somewhere around Fifteenth and Walnut, Cynthia suddenly spoke out of the back. “I know where she is, you wanna talk with her.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He glanced in the mirror, realizing what she was saying. “Where?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Cost you another ten.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He laughed that she’d got her nerve back. “And here I am giving you and your mutt a free ride.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Fine, take it outta my fare. You got a pen?” she asked. “I’ll write it down for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He took out the pocket notebook he used as a log and opened it to the back page, handed her a pencil."), _c('span', {
    staticClass: "Bold-Style",
    attrs: {
      "lang": "en-US"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("While she wrote, she said, “Cops interviewed the three of us in the same room. She gave up an address. Might be phony, but it’s up in the Fairmount. Brown Street.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("In the mirror he watched her scribble in the notebook. “Why in the name of God did Kid go to work for him?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She looked up at the gaze of his reflection, her eyes bright and wet. “If you don’t know, then nobody does, honey. Didn’t tell me nothin’.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He focused on the street again. Yeah, he knew. A lot of dollars and no sense.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Fifteen minutes later, Meyers pulled the cab into a space on Aspen Street, then strode on up the hill to Brown at the top of the ridge. This woman lived within spitting distance of Eastern State, and he wondered if she had maybe some relationship to the prison. Or maybe it was just cheap rent.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Kennealy’s Bar stood on the corner of Twenty-Second and Brown, and as he rounded the corner, a couple of women came out of the ladies’ entrance at the back. They were babbling happily at each other in Polish. He’d worked with enough Polish fighters in his time to know the sound of it. He slowed his pace and strolled up beside them. “Evening, ladies,” he said. “How are you this fine night?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The duo laughed a little nervously, and Meyers smiled. He chatted about nothing, and they kept walking. They soon passed the address Cynthia had given him. Without appearing to look, he noticed the glow of a cigarette in a doorway across the street. Meyers walked another block with the women, then tipped his cap and turned away. He crossed the street. After a minute he started back the way he’d come, but at double the pace now, feet hitting the pavement with the sound of someone in a hurry. The doorway lay just ahead. ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He barreled along and at the last instant as he was passing the door he pivoted on one foot and punched a short jab straight into a solar plexus. The man in the shadows didn’t even have time to raise his hands in defense. He folded around the fist, spitting the cigarette past Meyers, who swung his right into the man’s jaw so hard that the body bounced off the door and against the brick around it. Meyers was ready to hit him again if necessary, but he slid down onto the step and tipped onto his side. Meyers yanked him upright and pushed his legs back into the shadows. He patted the body down and reached into the coat. He drew out a wallet—and a badge.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("This was not good.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He stuffed the possessions back inside the jacket. The cop groaned. Meyers turned and walked quickly across the street.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Beside the door was a panel with three buttons, no doubt one apartment for each floor of the row house. The first two had names beside them. The third-floor label was blank. He pressed the button. Even as he did, he realized how stupid it was. She had no reason to let him in, and if she was hiding from trouble, she wasn’t going to let anybody in at all. To his surprise, though, the door buzzed and clicked on its latch, and he pushed inside before she could change her mind. He took the stairs two at a time.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The door at the top hung ajar, and he hesitated then, feeling a little too much like a fly visiting a spider. He looked at the name Cynthia had written down. “Miss Luka … chova?” he called.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Come,” she answered as if granting him an audience.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The apartment had a short, narrow foyer that opened on a living room, with a kitchen off to the right and another doorway, presumably the bedroom, at the back. One low-wattage wall sconce—a fake candle under a little paper shade—lit the room a diseased yellow.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The woman was sitting on a ragged love seat against the wall. Her legs were crossed at the knee. She had long black hair and wore a gray dress and a jacket that had an almost military cut to it. She was smoking a long, odd-shaped cigarette, and her large eyes glittered behind the stream of smoke. She leaned forward and tapped her ash against a glass ashtray on the small white coffee table in front of her. A scattering of tarnished coins or buttons lay strewn across the tabletop. They had an oily sheen. Meyers stayed in the doorway, his hands balled into fists in his pockets, but nothing else in the place seemed to be moving.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Who are you?” she asked in a voice that sounded like it didn’t much care. “You are not from Drozdov.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You’re right on that score. My name’s John Meyers. I was a friend of Kid Willette’s.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Who?” She seemed genuinely perplexed. What she didn’t seem was frightened. Cynthia, out in the open, had been more edgy than this. The woman seemed tired, as if she’d run out of gas well back down the road.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“He was one of the boys who worked for Cody Aldred.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Cody, yes. He was blond man?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yeah. He was a blond man.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Ah. I am sorry for your loss. I did not have opportunity to know him.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What happened, Miss Luka … What happened at the roadhouse?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You are not policeman?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No. I drive a cab. Willette used to be a boxer. I used to be a trainer.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Like father and son, no?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Meyers leaned against the jamb. “Not really, no.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She nodded solemnly. “But you feel you have duty to his memory.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Something like that, I suppose.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I understand. I even share your sentiment. If you would like a drink, I have vodka in icebox.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He shook off her invitation. “How’d you end up at the roadhouse?” he wanted to know.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" She hissed smoke. “Circumstance. I am wanting to meet a man I’ve heard of, but to do so I find I must first entertain this Cody.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She didn’t look at him, but off across the room as she spoke. He decided Cynthia was right—something boiled just beneath this dame’s cold surface. She spoke more English than she’d pretended, too. “So you came all the way from Estonia to work for Drozdov?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Her look stabbed him, but just as quickly she covered herself by leaning down and tapping her cigarette on the ashtray again. “Mr. Drozdov, he promises to help young women to escape Eastern bloc. Promises job. Promises life.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You know he’s selling you into prostitution, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Her lips curled. “Oh, yes, I know. I have no illusions.” Again she stared at him. “None. My sister, however, she did not understand this.” This time when she leaned forward, she smashed the gray cigarette into a blob.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Hair prickled on the back of Meyers’s neck. All of a sudden, he knew she’d killed Cody Aldred. Killed all of them. She must have accomplices, must have let someone in—he couldn’t figure it any other way. He also had a pretty good idea what had happened to her sister. Glancing into the doorways again, he tried to figure how it was she’d been left by herself. Maybe her pals couldn’t get near her now. “You know the police are watching your house?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What? They mustn’t. They mustn’t interfere!” She got to her feet. She was tall as a coat rack.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Bingo")]), _vm._v(", he thought. He replied, “Interfere with what?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("A buzzer went off beside the kitchen doorway. Meyers saw the metal switch plate on the wall, but the woman walked to it and pushed the black button on the plate before he had time to react. That would be the cops, and they would not be enthusiastic about his presence. In fact, chances were, he was in trouble. “Maybe I will have that vodka,” he said and pushed past her into the kitchen. A big tin icebox stood beside the doorway. He found the vodka on its side in a small compartment directly below the half-melted block of ice. He grabbed it by the neck, hefting it. Just in case.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Footsteps came up the stairs and into the apartment. Meyers leaned back against the kitchen wall, listening. The woman said something and then a man answered, but he wasn’t speaking English. His voice sounded pleasant, even friendly. Not cops, then. He had a pretty good idea who it was instead.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("There was a back door to the apartment off the kitchen, and as the voice got louder, coming deeper into the apartment, Meyers crept around the icebox and very cautiously opened the door.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("A man was standing there. He and Meyers looked at each other. The man’s hands were deep in his coat pockets, and he smiled as Meyers took this in, said, “How about we go back inside, pally. Nothing down in this alley but rats.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Meyers nodded and closed the door. When he turned around, two other men stood in the kitchen doorway. He walked back to them, and set the vodka onto the counter next to the fridge.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("In the other room a third man, with thick features and a large mustache, stood beside the woman. He beamed at Meyers. “Very nice work on that copper—you have excellent skills,” he said, his accent subtle. “All we had to do was tap him to keep him dreaming a little longer.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Sounds like it’s not his night.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Indeed. Now, you will please accompany us and Yuliya.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Why?” she said sharply. “He’s nobody to do with this. He is wanting to buy my time.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The man glowered at her. “You know that is a lie, my dear. What casual john eliminates police officers for a trick? Mr. Drozdov will want to hear what he says, as do I, even now.” His eyes slid back to Meyers, who tipped his head as if to say that it was all fine with him. The mustached man held Yuliya Lukachova’s coat for her. Then two of the men led the way out and down the stairs with Meyers and her sandwiched in between.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The Packard drove into a loading bay in a warehouse on Front Street. The air reeked of sour refinery, so the wind must have been blowing in from the west. At least it masked the fish stink of the Delaware, which wasn’t more than a quarter mile away past the warehouses. They walked by shredded cardboard cartons, broken pallets, and piles of newspaper that were probably used as packing material. Meyers wondered what they manufactured and shipped out of here.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The first time he’d ever seen Pankrat Drozdov was the night he’d fought Mickey Darren at Convention Hall. It was one of Herman Taylor’s bouts, a clean fight. He’d KO’d Darren in the seventh. At the time he didn’t know he just had three fights left before his inner ear went. That night he had only the memory of a dark-haired man with the face of a shark and an entourage of six, which included a woman on each arm. Drozdov had stood out, as he intended.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The next time was after Kid had thrown his fight. Meyers knew the Russkie had been behind it—some kind of bet had been placed. He supposed he should have credited Drozdov for picking Kid up afterward and giving him the job with Cody. Except Drozdov was the reason Kid needed the job, and the job was the reason Kid was dead.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Drozdov had some gray at his temples now, but he was still lean and hatchet faced. This close to him, Meyers realized it was the eyes that made him like a shark. They were black and empty, eyes that calculated how you were going to taste.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He sat at the end of a large, scarred wooden table surrounded by oak chairs, the kind Meyers remembered from high school. The table had leather straps nailed to the side of it at all four corners. The men sat the woman down beside Drozdov. One of them walked off into the back. The other two flanked her. Meyers wasn’t offered a seat. A new man, nibbling a toothpick, sidled up out of the shadows and stood next to him.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Well, well,” Drozdov said. “A long time it’s been since Darren went down. How have you been, Gospodin Meyers?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Well enough.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Vasily here tells me you’ve taken up our cause against the police.” Meyers shrugged. Drozdov leaned forward and took hold of Yuliya’s chin. His fingers closed on her jaw like a vise. “What is it you want with our lovely sister here?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Sister?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Drozdov chuckled. “Oh, not "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("my ")]), _vm._v("sister, Meyers.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The look in her eyes wasn’t just from pain, but fearful recognition. Drozdov was letting her know that he knew everything. He drew his hand back. She reached up to rub her face.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I was asking her about Kid,” Meyers said. “Because she was with Cody at the roadhouse.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You see?” Drozdov waved at Vasily. “A simple explanation. And it’s true. You can tell when someone’s telling the "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("truth")]), _vm._v(", you know?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Vasily’s gaze shifted to Meyers noncommittally.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The man who’d walked into the back returned carrying a large wooden box. An electric trouble light hung off the side, the cord slithering along behind it. The flat blade of a large wood-burning iron also poked up above the side of the box, looking like the tip of an enormous screwdriver. Meyers tensed. He thought of the hookers fished out of the river.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“So,” Drozdov said, “I’m inclined to send you home. Unless you would like to stay. I hope to learn something about the fate of Cody and Kid Willette, myself.” His thug set two of the irons, one small like a pencil and the larger one the size of a leek, down on the table beside him.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Yuliya Lukachova implored Meyers with her eyes and shook her head. He read the look as a plea: She must be shaking her head no, that she didn’t want him to leave her here. He couldn’t see a way out for her, though, and much as he wanted to, he couldn’t walk away. Maybe he could help her, but maybe—and the thought unsettled him—he would hear finally what he wanted to know. “Yeah,” he said, “I’ll stick around.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No!” she barked. Everyone looked at her, but she stared at Meyers. “You leave here. Now.” Turning to Drozdov, she said, “Get rid of him and I tell you what you want.” ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Drozdov casually picked up the smaller burner, touched it to the table. After a moment a tiny curl of smoke rose from the tip. “Not ready,” he said to no one and put it down. “Yuliya, believe me when I tell you, you’re going to give me everything anyway. I have found out some interesting facts about you since my dear friend Cody Aldred met you and his fate. And you know what I’m talking about.” He waited then, to see how she would answer.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Her eyes closed as if she’d dozed off. But then she drew a deep breath, and quietly said, “Liisu.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“There. That’s what I like—when you tell me things.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Still not looking at him, she replied flatly, “You killed her.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Drozdov’s bonhomie peeled away like a mask; the face of the shark returned. “Actually, "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I ")]), _vm._v("didn’t.” He raised the large iron. “This did. Would you like to know where I applied it? Ah, you know, I think I won’t tell you. But I will let you find out.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Meyers’s body was pumping adrenaline. Unable to act, he flexed his muscles, shifted his feet. The guy next to him eyed him sidelong, alert to the pent-up energy.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Yuliya Lukachova bowed her head, and her lips moved as in prayer. Drozdov frowned with disgust. Her breathy syllables grew slowly, steadily, into words, phrases, all of them alien to Meyers. Drozdov’s brow creased. The words perplexed him as well. He looked as if he had run out of patience with her, and his hand closed around the larger iron. She snarled strange words at him, and her hand came out of her pocket and flung blackness into his face. Small objects struck him and rained down onto the table, rolling, some of them, onto the floor. Meyers recognized the odd oily coins he’d seen in her apartment.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Drozdov began to laugh. One coin had stuck to his face, and he flicked it away.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The woman started to rise, and the goons behind her grabbed her by the arms. Drozdov sneered at her and picked up the iron. ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The spill of coins didn’t settle. They jittered and rolled, off the table, across the floor as if downhill. In seconds they’d collected in a single spot and begun to spin in place. Only Meyers and his guard seemed to notice. Everyone else was watching the red-hot iron.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Drozdov plucked hairs from her head and touched them to the iron’s tip. They vanished in a puff of smoke. “She wants to be on the table now,” he told the men.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("A breeze erupted through the huge space. From all around, loose objects started to skitter across the floor. They flew to where the black lump spun—broken splinters from the pallets, broken glass, papers, empty bottles, cardboard and tape, baling wire and small stones, mousetraps drawn out of corners, bricks that crumbled as they reached the spot. The box on the table flipped and the tools in it shot away from Drozdov. A trash container crashed. Its contents sailed across the floor. The air howled like something alive. The cage of the trouble light collapsed, and it whipped across the room. Drozdov reacted an instant too late, and the iron snapped from his grasp and flew behind it. The cord on the light whipped like a tail, and by the time the irons joined it, the thing had formed.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It stood like a man. For hands and fingers it had pliers, screwdrivers, nails, and the wood-burning irons that smoked and glowed. Black buttons punched the crumpled material of its face into eye sockets. The woman growled, “"), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Nuku-surnud")]), _vm._v(",” and the thing lunged at the table.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Vasily had his gun out. He fired repeatedly at the creature. It rammed the arm ending in the large iron straight into his skull. Flesh and brain sizzled. Its other arm buried in the chest of the second man holding Yuliya Lukachova, spinning, bursting out the back of him. It cut up and down, splitting him in half, and then went for Drozdov. He squealed and dodged aside. Meyers’s guard had run forward to help, and Drozdov grabbed him and threw him in the creature’s path, then barreled around the table.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The creature tore the man apart like it was opening an envelope. ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Yuliya Lukachova screamed at Meyers. “Get out of here, idiot!” she yelled. “It won’t stop now. Run from here!” She stood proud, tall, as pitiless as stone.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Drozdov clawed at him and Meyers punched him, smashing his nose. Drozdov fell against the table. He lunged for Meyers again, but jerked back so fiercely that his neck cracked. The creature had caught his collar. It slammed him onto the table. The large iron swept once around his throat, and suddenly his head was flying back into the depths of the warehouse while the body kicked and spasmed.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Meyers ran.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He dodged past the car and down the ramp to the open lot. He hesitated for only a second before racing toward the river—long enough to glance back and see the thing wedge itself around the Packard. It left a wet smear on the car.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He bolted across the open lot. The thing lumbered after him undeterred.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Soon he was in the grass, up a gravel slope and over the rails of the tracks that ran past the warehouses. When he looked back next he could feel the creeping edge of vertigo from his ear injury. He listened instead of looking back then, sure that swinging his head once more would tip the world over on him, and for certain if he fell the dingus would catch him.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It crashed noisily through the brush behind him, and that propelled him ahead. He thundered out onto the disused loading dock made of old wooden ties as the creature crossed the tracks and descended the bed.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Reaching the edge, Meyers dove into the blackness of the Delaware. Ships had taken on cargo here. It had to be deep enough to dive. He was depending on it.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He hit the icy water and swam for his life. The current clutched at him but he kicked furiously out into the river, refusing to be dragged under. He thought of the girls Drozdov had tortured and dumped, their corpses down below. He swam harder."), _c('span', {
    staticClass: "Bold-Style",
    attrs: {
      "lang": "en-US"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The creation of wood and glass and paper and metal leaped in after him. He heard the splash, dared a look back as it vanished into the black water. It surged up once, thrashed like a crazed animal at the surface, and then sank. This time it did not reappear, but Meyers turned and kept going, driven by the fear that any second, monstrous hands would snag him from below and pull him to his death.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He didn’t stop until he’d crawled up on the rocky Camden side. He was shivering. His breath steamed. He made himself get to his feet and go on, up and into the weeds. He stumbled and shuffled and kept moving, and maybe half a mile up found a service station by the side of the highway that was open and pumping gas. He went inside, pulled out a sodden five-dollar bill and begged the most expensive cup of coffee he’d ever had. The attendant eyed him as if debating whether to call the cops, but Meyers told him to keep the bill, and that settled that.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He held the stained mug in both shaking hands as he drank. Two other men, truck drivers, stared at him as they might have stared at a raccoon that had wandered in for a pack of Luckies. Nobody asked him what had happened, as if they knew the answer would be impossible to reconcile.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He drank a second cup before he set down the mug and headed out. The Delaware River Bridge wasn’t far. He took the footpath up alongside the cars passing from New Jersey to Pennsylvania. Every few feet he was compelled to glance back to confirm that the dingus wasn’t pursuing him. "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Dingus. That’s right. ")]), _vm._v("He laughed at the word, making a joke of the horror, and the fact that he’d escaped it.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The events rolled around in his head like marbles. The woman had created it, called it into being somehow. He’d seen it with his own eyes. Some kind of witch. She would’ve done the same at the roadhouse. Those coins, buttons, whatever they were. How many did she throw at Cody? Why was he wondering this? It was crazy. Coins that brought trash to life. ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He was cold and tired, and he’d just escaped from a goddamn dingus that nobody was ever going to believe in.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Back in Philly, he rode the Third Street Trolley to Fairmount Avenue and caught the Fairmount Trolley up past the prison. He sat away at the back of both by himself. It was coming up on seven in the morning. He smelled like the river; his clothes were damp; his hair was crazy. He looked like someone who’d gotten falling-down drunk in a fountain.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He was never so happy to see his cab as that morning. Tumbling into it, he spent a moment breathing in the stale, wonderful smell of Rosario’s cigars. A fit of laughter burst from him. He pounded the steering wheel and yelled and yelled until he’d worn out the terror. Then he started the cab, drove back to the depot and parked. Rosie would be showing up any minute for the day shift, but Meyers didn’t wait. He walked the few blocks home, stripped out of the wet clothes, and then, in dry shorts and undershirt, he opened a tin of beans, heated them up on the stove, and ate ravenously out of the pan, mopping up the red sauce with a hunk of bread. He wanted a pot of coffee and a steak.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The night’s events were bending into some warped dream. Meyers furiously scratched his cheek. He kept turning it all over in his head. Had everyone been killed? He tried to remember, but he wasn’t sure. Maybe one of the goons had escaped into the warehouse. And the woman, the witch, she’d gotten away, oh, yeah.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Getting away seemed like a very good idea. If any of Drozdov’s guys were still loose, they’d come after him to find her. Or maybe think he was part of it, in with her from the beginning. Sure. He’d been out for revenge for Kid. They’d think that, wouldn’t they? And what about the cops? The one he’d punched. He couldn’t be sure he hadn’t been recognized. And Bulbitch—imagine trying to sell him this story: a dingus that killed four armed men? Twice? Bulbitch had warned him to stay out of it, and unless the cops could buy into witches and papier-mâché monsters conjured from"), _c('span', {
    staticClass: "Bold-Style",
    attrs: {
      "lang": "en-US"
    }
  }), _vm._v("coins and buttons and crap, they’d hang this on him. If he hadn’t been there, hadn’t seen it himself …")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("San Francisco sounded awfully good. Bound to be a morning bus—get him as far as Pittsburgh before anyone knew to look for him. Arnie Slocum had moved out to Frisco to train fighters two years ago. Arnie would hand him a job right away.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("As he collected his whirling thoughts, he moved about the apartment, got out his suitcase, filled it with clothes. He needed a bath, but maybe not right now. Some clothes, some cash from the bank on the way. He grabbed his tip box out of the back of the closet and tossed two rolls of bills into the suitcase under the clothes. He’d call Rosie from the bus depot, tell him to hang onto the cab, he’d be in touch to work out the details later. Rosie’d find somebody to take the night shift for now.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Winter in California, that wasn’t such a bad fate. Let everything blow over and all the monsters wash out to sea.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("That was the plan congealing as he hauled the suitcase into the foyer. He paused to pull on his pea jacket, then grabbed the door handle in the same moment he heard his feet splash and looked down to see dark dirty river water pooling as it trickled in over the threshold. Meyers thought of Red in his roadhouse reaching for a brass knob, blood soaking into the sawdust below him, as the door of the apartment came off the latch. ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Gregory Frost is a writer of fantasy, horror, and science fiction who has been publishing steadily for more than two decades.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("His latest work is the fantasy duology "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Shadowbridge ")]), _vm._v("and "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Lord Tophet")]), _vm._v(", published by Del Rey Books. His earlier novels include "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Fitcher’s Brides")]), _vm._v(", a World Fantasy Award and International Horror Guild Award finalist for Best Novel; "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Tain")]), _vm._v("; "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Lyrec")]), _vm._v("; and Nebula-nominated science-fiction work "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The Pure Cold Light")]), _vm._v(". His short-story collection "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Attack of the Jazz Giants and Other Stories ")]), _vm._v("was called by "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Publishers Weekly ")]), _vm._v("“one of the best fantasy collections of the year.” He is one of the Fiction Writing Workshop directors at Swarthmore College in Swarthmore, Pennsylvania, and has thrice taught the Clarion Science Fiction and Fantasy Writers’ Workshop.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("His website is GregoryFrost.com; his blog, "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Frostbites")]), _vm._v(", lurks at Frostokovich.LiveJournal.com.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3aac39ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/supernaturalepub1.vue
// module id = 78
// module chunks = 0